export const DIAGNOSTICS = {
  key: 'DIAGNOSTICS',
  value: 13,
  group: 3,
  title: 'health-record.labs.diagnostics',
  menu_title: 'health-record.labs.diagnostics',
  sub_title: 'Image',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Symptom-Checker.svg'),
  icon: 'monitor',
  editor: 'DiagnosticsEditor',
  message_translate: 'health-record.labs.message',
  model_name: 'lab',
  resource: 'hr/diagnostic/',
  plain_resource: 'diagnostic',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.labs.imaging-category',
      value: 'record.category',
    },
    {
      text: 'health-record.labs.lab-date',
      value: 'record.date_formatted',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      date_formatted: 'date',
      category: 'category',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #0097A7 3.07%, #4DD0E1 100%)',
  color: '#2FABE0',
  opaque: '#D1EAF5',
}
